/* Shared wording for simulations, so the list, the dashboard and the
 * simulation page describe a run in the same words. */

import type { ManualRule, SimulationOptions, SimulationSummary } from '../api/client'

export const RULES: { id: ManualRule; label: string; note: string }[] = [
  { id: 'plant_calendar', label: 'Plant calendar', note: 'every crew works the days the plant is open' },
  { id: 'fixed', label: 'Fixed days', note: 'every crew works N days per bucket, capped by the calendar' },
  { id: 'stop', label: 'Stop', note: 'the crews stop: a line down, a shutdown' },
  { id: 'keep', label: 'Keep the current days', note: 'recalculate only, e.g. to test other master data' },
]

export function modeLabel(mode: string): string {
  return mode === 'auto' ? 'Agentic' : 'Manual'
}

export function describeOptions(sim: Pick<SimulationSummary, 'mode' | 'options'>): string {
  const o: SimulationOptions = sim.options
  if (sim.mode === 'auto') {
    const ot = o.allow_overtime ? `overtime ≤ ${o.overtime_max_days ?? 1} d` : 'no overtime'
    return o.frozen_buckets ? `${ot} · ${o.frozen_buckets} frozen` : ot
  }
  const rule = RULES.find((r) => r.id === o.rule)?.label ?? o.rule ?? 'keep'
  const days = o.rule === 'fixed' ? ` ${o.days ?? 0} days` : ''
  const range =
    o.from_bucket != null || o.to_bucket != null
      ? ` · buckets ${o.from_bucket ?? 0}–${o.to_bucket ?? 'end'}`
      : ''
  const crews = o.crews?.length ? ` · crews ${o.crews.join(', ')}` : ''
  return `${rule}${days}${range}${crews}`
}

export function when(iso: string | null): string {
  if (!iso) return '—'
  const d = new Date(iso)
  return d.toLocaleString(undefined, {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

export function round(value: number): string {
  return Number.isInteger(value) ? String(value) : value.toFixed(1)
}
